import { serviceLoading } from 'common/loaderReducer';
import { SearchableDropdown } from 'components/SearchableDropdown';
import { GET_DEALER_API_REQUEST } from 'features/Dealers/DealerSelect/state/actionTypes';
import { DEFAULT_PAGE_SIZE } from 'features/Dealers/DealerSelect/state/constants';
import * as React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation, Redirect } from 'react-router';
import { RootState } from 'store/types';
import { dealersLoadMore, editDealerSearchQuery, editSelectedDealer, getDealerAPI } from './state/actions';
import { Dealer } from './state/types';
import { getEngineDealerAPI } from 'features/Dealers/state/actions'
import { convertToObject } from 'typescript';
import { getDealerListingsWithErrors } from 'features/Dealers/Listings/state/actions';

export interface RootProps {
    dealers: Dealer[]
}

const DealerSelect = (props: any) => {
    const dispatch = useDispatch();
    const location = useLocation()
    const history = useHistory();

    const [isSelecting, setIsSelecting] = React.useState(false);

    const rootProps = useSelector((rootState: RootState) => {
        const isLoadingMoreDealers = serviceLoading(rootState, [GET_DEALER_API_REQUEST]);
        const isLoadingInitialDealers = rootState.dealers.dealer.page === 0 && isLoadingMoreDealers
        const canLoadMore = rootState.dealers.dealer.lastPageSize ? rootState.dealers.dealer.lastPageSize === DEFAULT_PAGE_SIZE : true        
        return {
            dealers: rootState.dealers.dealer.dealers,
            isLoadingMoreDealers,
            isLoadingInitialDealers,
            canLoadMore,
            query: rootState.dealers.dealer.query,
            selectedDealer: rootState.dealers.dealer.selectedDealer,
            user:rootState.security.user,
            engineDealer: rootState.dealers.enginedealer.enginedealer
        }
    }, shallowEqual);

    React.useEffect(() => {
        if (rootProps.selectedDealer && isSelecting) {
            history.push({
                pathname: `/dealer/primary`,
                search: `?dealer=${rootProps.selectedDealer.id}`
            })
            setIsSelecting(false);
        }
        else
        {
            const dealerId = new URLSearchParams(location.search).get("dealer")
            if (dealerId== undefined)
            {
                if (rootProps.user)
                {
                    history.push({
                        pathname: `/dealer/primary`,    
                        search: `?dealer=${rootProps.user.dealerId}`
                    })
                }
            }
        }

    }, [rootProps.selectedDealer])

    React.useEffect(() => {    
        if (rootProps.selectedDealer && rootProps.selectedDealer?.id) {
            dispatch(getDealerListingsWithErrors(rootProps.selectedDealer.id));
        }
    }, [rootProps.selectedDealer?.id])


    const suggestItems = React.useMemo(() => {    
        if (rootProps.dealers) {
            const onlyInterestedDealers = rootProps.dealers
                .filter(o => o.name.toLocaleLowerCase().includes(rootProps.query.toLocaleLowerCase())
                    || o.id.toLocaleLowerCase().includes(rootProps.query.toLocaleLowerCase()));
            return onlyInterestedDealers.map(dealer => ({
                id: dealer.id,
                displayName: `${dealer.name} - ${dealer.id}`
            }))
        }
        return undefined;

    }, [rootProps.dealers, rootProps.query])

    const getPlaceHolder =  () => {
        return (rootProps.selectedDealer && rootProps.selectedDealer?.id && rootProps.selectedDealer?.name) 
                ? `${rootProps.selectedDealer?.name} - ${rootProps.selectedDealer?.id}` 
                : "Search Dealers";
    }

    if (!rootProps.dealers) {
        return null
    }

    return (
        <SearchableDropdown
            value={rootProps.query}
            options={suggestItems}
            isLoading={rootProps.isLoadingInitialDealers}
            canLoadMoreOptions={rootProps.canLoadMore}
            emptyText={getEmptyText()}
            placeholder={getPlaceHolder()}
            readonly={false}
            onValueChange={(v) => onSearchQueryChange(v)}
            onOptionSelected={onSelectedItem}
            onDrawerDismissed={onDrawerDismissed}
            onLoadMoreOptions={loadMoreOptions}
            inputStyle={{height: "36px", borderRadius: "5px"}}
            labelStyle={{color: "#9c9c9c", fontSize: "14px", letterSpacing: "normal"}}
        />
    )

    function onSearchQueryChange(query) {
        dispatch(editDealerSearchQuery(query))
    }

    function loadMoreOptions() {
        dispatch(dealersLoadMore())
    }

    function getEmptyText() {
        if (rootProps.isLoadingInitialDealers) {
            if (rootProps.query === "") {
                return "Loading..."
            } else {
                return `Searching "${rootProps.query}"`
            }
        } else {
            if (rootProps.query !== "") {
                return `No Dealers found for "${rootProps.query}"`
            } else {
                return `No Dealers found`
            }
        }
    }

    function onDrawerDismissed() {
        dispatch(editDealerSearchQuery(""));
    }

    function onSelectedItem(item) {
        const dealer = rootProps.dealers?.find(d => d.id === item.id)
        
        if (dealer) {
            setIsSelecting(true);
            dispatch(editSelectedDealer(dealer))
        }
    }
}

export default DealerSelect;
